
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explained/[slug]",
      function () {
        return require("private-next-pages/explained/[slug]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/explained/[slug]"])
      });
    }
  